import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import './SlidingPanesWidget.scss';

const SlidingPanesWidget = ( {
  activeSlidingPaneIndex,
  children,
  paneWidths,
} ) => {
  const [ sliderPosition, setSliderPosition ] = useState( 0 );

  useEffect( () => {
    if ( paneWidths && Object.keys( paneWidths ).length > 0 ) {
      // Add all the previous pane widths together.
      const totalPreviousWidths = Object.keys( paneWidths )
        .filter( ( key ) => parseInt( key, 10 ) < activeSlidingPaneIndex )
        .reduce( ( total, key ) => total + ( paneWidths[key] || 0 ), 0 );
      setSliderPosition( totalPreviousWidths );
    }
  }, [ activeSlidingPaneIndex, paneWidths ] );

  return (
    <div
      className="slidingPanesWidget"
      style={{ transform: `translateX(-${sliderPosition}px)` }}
    >
      { children }
    </div>
  );
};

SlidingPanesWidget.propTypes = {
  activeSlidingPaneIndex: PropTypes.number,
  children: PropTypes.node,
  paneWidths: PropTypes.object,
};

SlidingPanesWidget.defaultProps = {
  activeSlidingPaneIndex: 0,
  children: null,
  paneWidths: {},
};

export default SlidingPanesWidget;
